if (!customElements.get('hh-pdp-quantity')) {
  customElements.define('hh-pdp-quantity', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const input = this.querySelector('input');
      if (!input) return;
      const update = () => {
        const min = Number(input.min) || 1;
        const max = Number(input.max) || 10;
        input.value = Math.min(max, Math.max(min, Math.round(Number(input.value) || min)));
        this.querySelector('[data-step="-1"]').disabled = Number(input.value) <= min;
        this.querySelector('[data-step="1"]').disabled = Number(input.value) >= max;
      };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-step]');
        if (!button || button.disabled) return;
        input.value = Number(input.value) + Number(button.dataset.step);
        update();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      input.addEventListener('change', update);
      update();
    }
  });
}
